function toTimestamp(creationTime) {
    if (!creationTime)
        return Date.now();
    return creationTime < 1e12 ? creationTime * 1000 : creationTime;
}
function flattenTree(treeNode, result, parentPath) {
    let displayName = treeNode.value?.toString() || "";
    if (displayName === "dataOwnerFiles") {
        displayName = "Files";
    }
    const currentPath = parentPath === "" ? "/User Files" : parentPath;
    result.push({
        name: displayName,
        isDirectory: true,
        path: currentPath,
        updatedAt: toTimestamp(treeNode.properties.creationTime),
        id: String(treeNode.id),
        size: 0,
        fileType: "folder",
        graphNodeId: treeNode.id,
        node: treeNode,
    });
    if (!treeNode.content || treeNode.content.length === 0)
        return;
    for (const child of treeNode.content) {
        if (!child.properties.isFile) {
            flattenTree(child, result, currentPath + "/" + child.value);
        }
        else {
            const storageId = child.properties.fileStorageId || "";
            const filePath = storageId.includes("User Files")
                ? "/" + storageId
                : "/User Files" + storageId;
            result.push({
                name: child.properties.fileName || child.value || "",
                isDirectory: false,
                path: filePath,
                updatedAt: toTimestamp(child.properties.creationTime),
                size: child.properties.fileSize || 0,
                id: String(child.id),
                fileType: child.properties.fileMimeType || undefined,
                graphNodeId: child.id,
                node: child,
            });
        }
    }
}
export function buildFileList(tree) {
    const result = [];
    flattenTree(tree, result, "");
    return result;
}
